// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getClaimRoutes} from '../../../shared/components/create-claim-modal/get-claim-routes-service';
import {routerActions} from 'react-router-redux';

export const updateCreateClaimModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_PRODUCT_DETAILS_CREATE_CLAIM_MODAL_VISIBILITY
        });

    };

export const onCreateClaim = (key, pin) =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');
        dispatch(routerActions.push(getClaimRoutes(key, pin)));

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/create-claim-modal-visibility.js